import React, {useState, useEffect, useRef} from "react";
import {Card, CardBody, Container, Row, Col} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";


import {Avatar, Button, DatePicker, Pagination, Tag} from "antd";

import Select from "react-select";
import "bootstrap/dist/css/bootstrap.css";

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import PlantaoModal from "../dashboard/calender/plantaoModal";
import AuthService from "../login/AuthService";
import moment from "moment";
import "moment/locale/pt-br";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Importando o CSS do skeleton loader
import './assets/css/Managers.css';

import HospitalSearch from "../hospital/HospitalSearch";
import Swal from "sweetalert2";

import LoadingScreen from "../util/LoadingScreen";
import CustomPagination from "../util/CustomPagination";
import ManagersModal from "./ManagersModal";
import ManagersRegisterModal from "./ManagersRegisterModal";
import UsersSearch from "../dashboard/calender/UsersSearch";


moment.locale('pt-br');

const Managers = () => {
    document.title = "Gestores | Plantão Rápido";
    const hospitalSearchRef = useRef(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [showManagersListModal, setShowManagersListModal] = useState(false);
    const [showRegisterManagersModal, setShowRegisterManagersModal] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const [hospitalSelectManagers, setHospitalSelectManagers] = useState(false);

    const [departmentsFilter, setDepartmentsFilter] = useState([]);
    const [userSelect, setUserSelect] = useState([]);

    const [users, setUsers] = useState([]);
    const [filters, setFilters] = useState({
        dateRange: "",
        status: null,
        hospital: "",
    });


    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});


    const handlePageChange = (page) => {
        fetch(page);
    };

    const fetch = async (page = 1) => {
        try {
            setLoadingSearch(true);
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}managers/list-user`,
                {
                    pagination: pagination.pageSize,
                    page: page,
                    status: filters?.status?.value,
                    hospital_id: filters?.hospital
                },
                true
            );
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setUsers(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSearch(false);
        }
    };


    const onHospitalSelect = (hospital) => {
        if (hospital && hospital.value) {
            // Somente atualiza o filtro se o hospital tiver um ID válido
            setFilters((prevFilters) => ({
                ...prevFilters,
                hospital: hospital.value
            }));
        } else {
            // Se nenhum hospital for selecionado (hospital é null), limpe o filtro
            setFilters((prevFilters) => ({
                ...prevFilters,
                hospital: null
            }));
        }
    };

    const handleHospitalSelect = async (hospital) => {

        if (hospital && hospital.value) {
            try {
                // Enviar requisição para registrar o hospital para o usuário
                setLoadingPage(true);
                const response = await ApiService.send(
                    "put", // Alterei para "post" caso esteja criando o registro
                    `${process.env.REACT_APP_URL_API}hospitals/users-register`,
                    {hospital_id: hospital.value},
                    true
                );
                setLoadingPage(false);

                Swal.fire('Sucesso', 'Hospital registrado com sucesso!', 'success')
                    .then(() => {
                        handleManagersListModalClose();

                    });


            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setLoadingPage(false);
            }
        } else {
            Swal.fire('Erro', 'Hospital não selecionado corretamente', 'error');
        }
    };


    const handleModalRegister = async (user) => {
        setShowRegisterManagersModal(true);
        setUserSelect(user);
    };

    const handleModalList = async (user) => {
        setUserSelect(user)
        setShowManagersListModal(true);
    };


    const handleClearFilters = () => {
        setFilters({
            dateRange: "",
            status: null,
            hospital: null,
            departament_id: null
        });

        // Chamar a função clearHospital() no HospitalSearch
        if (hospitalSearchRef.current) {
            hospitalSearchRef.current.clearHospital();
        }
    };

    const handleManagersListModalClose = (save =false) => {
        setShowManagersListModal(false);
        if(save) {
            fetch(1);
        }
    };


    const handleRegisterManagersModalClose = (save = false) => {
        setShowRegisterManagersModal(false);

        if(save){
            fetch();
        }
    };

    useEffect(() => {
        fetch();
        fetchDepartmentsFilter();
    }, []);

    const handleChange = (selectedOption) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            status: selectedOption,
        }));
    };

    const fetchDepartmentsFilter = async () => {
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/list-department`,
                {all: true, status: 'S'},
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);

                setDepartmentsFilter(
                    Array.isArray(data) ? data : []
                );
            } else {
                Swal.fire("Erro", "Erro ao carregar os departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setDepartments([]);
        }
    };


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Gestores" pageTitle="Configuração"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>} {/* Exibe o LoadingScreen durante operações */}

                                    <div className="col-md-4 form-group">
                                        <UsersSearch
                                            onUserSelect={(user) =>
                                                setFilters((prevFilters) => ({
                                                    ...prevFilters,
                                                    user_id: user?.value || "",
                                                }))
                                            }
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <HospitalSearch
                                            buttonAdd={false}
                                            ref={hospitalSearchRef}
                                            onHospitalSelect={onHospitalSelect}
                                        />
                                    </div>
                                    <div className="col-md-4 form-group">
                                        <label>Departamentos</label>
                                        <Select

                                            options={departmentsFilter.map((dept) => ({
                                                value: dept.id,
                                                label: dept.name,
                                            }))}
                                            onChange={(dept) =>
                                                setFilters((prevFilters) => ({
                                                    ...prevFilters,
                                                    departament_id: dept?.value || "",
                                                }))}

                                            classNamePrefix="select"
                                            placeholder="Selecionar Departamento..." // Define o texto interno
                                            menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                            styles={{
                                                menuPortal: base => ({
                                                    ...base,
                                                    zIndex: 9999
                                                }), // Definindo z-index alto
                                                menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                            }}
                                        />

                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-md-12 d-flex justify-content-end">

                                            <button type="button" className="btn  mr-1  me-2"
                                                    onClick={() =>handleClearFilters()}>
                                                <i className="fa fa-eraser"></i> Limpar Filtros
                                            </button>

                                            <button type="button" className="btn btn-info mr-1  me-2"
                                                    onClick={() => handleModalRegister(null)}>
                                                <i className="fa fa-plus"></i> Cadastrar Regra
                                            </button>

                                            <button type="button" className="btn btn-success"
                                                    onClick={() => fetch()}
                                                    disabled={loadingSearch}
                                            >
                                                <i className={`fa ${loadingSearch ? "spinner-border spinner-border-sm me-2" : "fa-search"}`}></i>{" "}
                                                {loadingSearch ? "Buscando..." : "Buscar Usuário"}
                                            </button>
                                        </div>
                                    </div>


                        <div className="list-container mt-4">
                            {loadingSearch ? (
                                <Skeleton count={5} height={120}/>
                            ) : users.length > 0 ? (
                                users.map((data) => (
                                    <Col lg={12} key={data.id}>
                                        <Card className="mb-1 p-2 shadow-sm card-hover">
                                            <CardBody
                                                className="card-body d-flex justify-content-between align-items-center p-2">
                                                <div className="col-10 d-flex align-items-center">
                                                    <div className="col-1 me-3"> {/* Aumentei o espaço entre o avatar e o conteúdo */}
                                                        <Avatar
                                                            src={data?.user?.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                            size={60}
                                                            className="me-2"
                                                            alt={data.user?.name || "Usuário sem nome"}
                                                        />
                                                    </div>
                                                    <div className="col-9 ms-2">
                                                        <h6 className="doc-name">{data?.user?.name || "Usuário não identificado"}</h6>
                                                        <p className="text-muted mb-1">
                                                            <i className="fa fa-phone text-info me-2"></i>
                                                            Telefone: {data.user?.ddd && data.user?.phone ? `(${data.user.ddd}) ${data.user.phone}` : "Não informado"}
                                                        </p>
                                                        <p className="text-muted mb-1">
                                                            <i className="fa fa-envelope text-info me-2"></i>
                                                            Email: {data.user?.email ? `${data.user?.email}` : "Não informado"}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="row col-2 d-flex align-items-center">
                                                    <button type="button"
                                                        className="col-12 btn btn-sm btn-info"
                                                        onClick={() => handleModalRegister(data?.user, 'cancel')}>
                                                        <i className="fa fa-plus"></i> Cadastrar
                                                        Regra
                                                    </button>
                                                    <button type="button"
                                                        className="col-12 btn  btn-sm btn-outline-primary mt-2"
                                                        onClick={() => handleModalList(data?.user, 'accepted')}>
                                                        <i className="fa fa-list"></i> Listar
                                                        Regras
                                                    </button>
                                                </div>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <div className="alert alert-primary" role="alert">Nenhum funcionário
                                    encontrado para cadastro de regras
                                </div>
                            )}
                        </div>
                        <CustomPagination
                            pagination={pagination}
                            onChange={handlePageChange}
                        />


                        <ManagersModal
                            actionText="Registrar"
                            user={userSelect}
                            show={showManagersListModal}
                            onHide={handleManagersListModalClose}

                        />

                        <ManagersRegisterModal
                            show={showRegisterManagersModal}
                            onHide={handleRegisterManagersModalClose}
                            hospital={hospitalSelectManagers}
                            user={userSelect}
                        />


                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
        ;
};

export default Managers;
